import { ROLES } from "./Constants";
import store from "../store";

export const isSuperAdmin = () => {
  const roleType = store.getState().auth.admin.role.type;
  return roleType === ROLES.superAdmin;
};
